<div mat-dialog-title
     class="title">
  <div class="subtitle">{{ formTitle | translate }}</div>
  <button mat-icon-button
          mat-dialog-close
          tabindex="-1"
          [matTooltip]="'Close' | translate"
          class="close-button hidden">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <div class="line flex flex-col" *ngIf="isLangSelectable">
    <label class="language-label">{{ 'Available_languages' | translate }}:</label>
    <div class="language-checkbox-group">
    <mat-checkbox
      *ngFor="let lang of availableLangs"
      [ngModel]="isLangSelected(lang.id) || false"
      (ngModelChange)="toggleLanguage(lang.id, $event)">
      {{ lang.shortName }}
    </mat-checkbox>
    </div>
    <mat-error *ngIf="languagesFormControl.invalid">
      {{ 'select_at_least_one_language' | translate }}
    </mat-error>
  </div>
  <div class="line">
    <mat-form-field color="primary">
      <input matInput
             #nameInput
             [required]="true"
             [formControl]="nameFormControl"
             type="text"
             maxlength="{{ NAME_MAX_LENGTH }}"
             [placeholder]="'Name' | translate">
      <mat-hint align="end">{{ nameInput.value.length }} / {{ NAME_MAX_LENGTH }}</mat-hint>
      <mat-error *ngIf="nameFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
    </mat-form-field>
  </div>
  <mat-error *ngIf="exerciceTypeFormControl.hasError('required') && this.exerciceTypeTouched">{{ 'Field_required' | translate }}</mat-error>
  <div class="line line-margin" [class.hidden]="hideDuration">
    <mat-radio-group [formControl]="exerciceTypeFormControl" [disabled]="disableDuration" class="flex">
      <mat-radio-button [value]="EXERCICE_TYPE_REPEAT"
                        (change)="onExerciceTypeChanged(EXERCICE_TYPE_REPEAT)"
                        class="matRadio2Col">
        {{ 'Repetitions' | translate }}
      </mat-radio-button>
      <mat-radio-button [value]="EXERCICE_TYPE_DURATION"
                        (change)="onExerciceTypeChanged(EXERCICE_TYPE_DURATION)"
                        class="matRadio2Col">
        {{ 'Duration' | translate }}
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="line"
       [class.hidden]="hideDuration">
    <duration-control #durationControl
                      [(value)]="duration"
                      [displayMode]="displayTimeMode"
                      [disabled]="disableDuration"
                      [label]="durationPlaceholder | translate"
                      [min]="MIN_DURATION">
    </duration-control>
  </div>
  <div *ngFor="let formControl of categoriesFormControls; let i = index"
       class="line">
    <mat-form-field color="primary">
      <mat-select placeholder="{{ 'Accent_x' | translate:{x: i+1} }}"
                  [formControl]="formControl"
                  (selectionChange)="onAccentChanged($event)">
        <mat-select-trigger>
          <span class="category-color" [style.background-color]="getSelectedCategoryColor(i)"></span>&nbsp;{{ getSelectedCategoryName(i) }}
        </mat-select-trigger>
        <mat-option *ngFor="let category of availableExerciceCategories"
                    [value]="category.id"
                    [disabled]="isAccentOptionDisabled(category, formControl)">
          <!--                  TODO : FIX WHEN #53 is fixed-->
          <span class="category-color" [style.background-color]="category.colorHex"></span>&nbsp;{{ category.name ?? category.translations[0].name }}
        </mat-option>
        <mat-option (click)="onAccentNoneClicked(formControl)"
                    class="none-option">
          {{ 'None' | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <!--
  <div class="line">
      <mat-form-field color="primary">
          <mat-select placeholder="{{ 'Accents' | translate }}"
                      [formControl]="categoriesFormControl"
                      multiple>
              <mat-option *ngFor="let category of availableExerciceCategories"
                          [value]="category"
                          [disabled]="categoriesFormControl.value.length === CATEGORIES_MAX_COUNT && categoriesFormControl.value.indexOf(category) < 0">
                  <span class="category-color" [style.background-color]="category.colorHex"></span>&nbsp;{{ category.name }}
              </mat-option>
          </mat-select>
          <mat-hint align="end">{{ 'Max_selected_options' | translate:{max: CATEGORIES_MAX_COUNT} }}</mat-hint>
      </mat-form-field>
  </div>
      -->
  <div class="line">
    <mat-form-field color="primary">
            <textarea matInput
                      [formControl]="descriptionFormControl"
                      class="text-area-unresizable"
                      maxlength="{{ DESCRIPTION_MAX_LENGTH }}"
                      #descriptionInput
                      cdkTextareaAutosize
                      placeholder="{{ 'Description' | translate }}"></textarea>
      <mat-hint align="end">{{ descriptionInput.value.length }} / {{ DESCRIPTION_MAX_LENGTH }}</mat-hint>
    </mat-form-field>
  </div>
  <div class="line line-large-margin">
    <mat-form-field color="primary">
      <input matInput
             #tagsInput
             [formControl]="tagsFormControl"
             type="text"
             maxlength="{{ TAGS_MAX_LENGTH }}"
             [placeholder]="'Tags' | translate">
      <mat-error *ngIf="tagsFormControl.invalid">{{ 'insert_at_least_one_tag' | translate }}</mat-error>
      <mat-hint align="end">{{ 'Tags_hint' | translate }}</mat-hint>
    </mat-form-field>
  </div>


  <div class="line">
    <mat-form-field color="primary">
      <input matInput
             #videoLinkInput
             [formControl]="videoLinkFormControl"
             type="text"
             maxlength="{{ VIDEO_LINK_MAX_LENGTH }}"
             [placeholder]="'Video_link' | translate">
      <mat-hint align="end">{{ 'Video_link_hint' | translate:{link: 'https://youtu.be/BDHEdQgjg50'} }}</mat-hint>
      <mat-error *ngIf="videoLinkFormControl.invalid">{{ 'Invalid_value' | translate }}</mat-error>
    </mat-form-field>
  </div>
  <div class="line switch-button-container">
    <div class="transcode-warning" *ngIf="isVideoBeingTranscoded()">
      {{ 'video_is_transcondig'|translate }}
    </div>
    
    <div class="switch-button-title">
      {{ 'Media' | translate }}
    </div>

    <div class="switch-buttons" [class.disabled]="isVideoBeingTranscoded()">
      <div class="switch-button" [ngClass]="{'active': fileType === 'image'}" (click)="onFileTypeChanged('image')">
        {{ 'Image' | translate }}
      </div>
      <div class="switch-button" [ngClass]="{'active': fileType === 'video'}" (click)="onFileTypeChanged('video')">
        {{ 'Video' | translate }}
      </div>
    </div>
  </div>
  <div class="line file-input-container" [class.disabled]="isVideoBeingTranscoded()">
    <!--    input fields-->
    <input-file *ngIf="fileType === 'video'"
                [allowedExtensions]="VIDEO_FILE_EXTENSIONS"
                [maxFileSize]="VIDEO_FILE_MAX_SIZE"
                [previewImage]="videoPreview"
                [hint]="'Video_file_hint' | translate:{duration: VIDEO_MAX_DURATION, size: VIDEO_FILE_MAX_SIZE}"
                (onFileDelete)="onVideoDelete()"
                [(fileData)]="videoFileData">
    </input-file>
    <input-image *ngIf="fileType === 'image'"
                 [maxFileSize]="IMAGE_MAX_SIZE"
                 [previewImage]="imagePreview"
                 (onFileDelete)="onImageDelete()"
                 [hint]="'Image_file_hint' | translate:{width: IMAGE_MAX_WIDTH, height: IMAGE_MAX_HEIGHT, size: IMAGE_MAX_SIZE}"
                 [(ngModel)]="imageImageData">
    </input-image>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div *ngIf="saveInfo"
       class="line save-info">
    <mat-icon>help_outline</mat-icon>
    <span>{{ saveInfo }}</span>
  </div>
  <div class="actions">
    <button mat-button
            mat-dialog-close
            tabindex="-1">
      {{ 'Cancel' | translate}}
    </button>
    <button mat-raised-button
            (click)="onSaveClicked()"
            color="accent">
      {{ confirmButtonTitle | translate}}
    </button>
  </div>
</mat-dialog-actions>
<div class="progress-container">
  <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
</div>
